import Vue from "vue";
import VueRouter from "vue-router";
import Cookie from "js-cookie";

import Home from "../pages/Home.vue";
import Main from "../pages/Main.vue";
import Login from "../pages/Login.vue";

import NotFound from "../pages/NotFound.vue";

Vue.use(VueRouter);
const routers = [
  {
    name: "main",
    path: "/",
    redirect: "/home",
    component: Main,
    meta: { title: "首页" },
    children: [
      { name: "home", path: "/home", component: Home, meta: { title: "首页" } },
      {
        name: "adminList",
        path: "/adminList",
        component: ()=>import("@/pages/adminList.vue"),
        meta: { title: "管理员列表" },
      },
      {
        name: "resume",
        path: "/resume",
        component: ()=>import("@/pages/resume.vue"),
        meta: { title: "简历库" },
      },
      {
        name: "meeting",
        path: "/meeting",
        component: ()=>import("@/pages/meeting.vue"),
        meta: { title: "会议管理" },
      },
      {
        name: "regisList",
        path: "/regisList",
        component: ()=>import("@/pages/regisList.vue"),
        meta: { title: "报名列表" },
      },
      {
        name: "invitation",
        path: "/invitation",
        component: ()=>import("@/pages/invitation.vue"),
        meta: { title: "邀请函管理" },
      },
      {
        name: "refundList",
        path: "/refundList",
        component: ()=>import("@/pages/refundList.vue"),
        meta: { title: "退费管理" },
      },
      {
        name: "UserCard",
        path: "/user/userCard",
        component: ()=>import("@/pages/user/userCard.vue"),
        meta: { title: "用户卡片" },
      },
      {
        name: "UserCard",
        path: "/user/userList",
        component: ()=>import("@/pages/user/userList.vue"),
        meta: { title: "用户列表" },
      },
     
      {
        name: "MedicCard",
        path: "/medic/card",
        component: ()=>import("@/pages/medic/card.vue"),
        meta: { title: "医生卡片" },
      },
      {
        name: "MedicList",
        path: "/medic/list",
        component: ()=>import("@/pages/medic/list.vue"),
        meta: { title: "医生列表" },
      },
    ],
  },
  {
    name: "login",
    path: "/login",
    component: Login,
  },
  {
    path: "*",
    component: NotFound,
  },
];
const router = new VueRouter({
  routes: routers,
});

//添加全局前置路由守卫
router.beforeEach((to, from, next) => {
  //判断token是否存在
  const token = Cookie.get("token");
  if (!token && to.name !== "login") {
    next({ name: "login" });
  } else if (token && to.name === "login") {
    next({ name: "home" });
  } else {
    next();
  }
});

// router.addChildrenRoute = (router) => {
//   if (!Cookie.get("menu")) {
//     return;
//   }
//   const menu = JSON.parse(Cookie.get("menu"));
//   //组装动态路由数据
//   const menuArray = [];
//   menu.forEach((item) => {
//     if (item.children) {
//       item.children = item.children.map((item) => {
//         item.component = () => import(`@/pages/${item.url}`);
//         item.meta = { title: item.label };
//         return item;
//       });
//       menuArray.push(...item.children);
//     } else {
//       item.component = () => import(`@/pages/${item.url}`);
//       item.meta = { title: item.label };
//       menuArray.push(item);
//     }
//   });
//   menuArray.forEach((item) => {
//     router.addRoute("main", item);
//   });
// };

router.resetRouter = function () {
  const newRouter = new VueRouter({
    routes: routers,
  }); 
  this.matcher = newRouter.matcher; //替换成新的空路由
};

export default router; 
